/**
 * Web-Mercator pixel math for the draggable Static-Maps panel: shift a map CENTER by a pixel
 * delta at a given zoom (Google's world = 256·2^zoom px). Dragging the IMAGE by (dx, dy) screen
 * pixels moves the center by (−dx, −dy) map pixels — callers pass the map-pixel delta.
 */
export function shiftLatLng(
  lat: number,
  long: number,
  dxPx: number,
  dyPx: number,
  zoom: number,
): { lat: number; long: number } {
  const worldPx = 256 * 2 ** zoom;
  const x = ((long + 180) / 360) * worldPx;
  const sinY = Math.sin((lat * Math.PI) / 180);
  const y = (0.5 - Math.log((1 + sinY) / (1 - sinY)) / (4 * Math.PI)) * worldPx;
  const nextX = x + dxPx;
  const nextY = Math.min(Math.max(y + dyPx, 0), worldPx); // clamp at the poles
  const nextLong = (((nextX / worldPx) * 360 - 180 + 540) % 360) - 180; // wrap the antimeridian
  const n = Math.PI - (2 * Math.PI * nextY) / worldPx;
  const nextLat = (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
  return { lat: nextLat, long: nextLong };
}
